import { Controller } from "@hotwired/stimulus"

// Auto-starts the global floating podcast player when a podcast detail
// page loads, by dispatching the same window-level `podcast:play` event
// the discovery cards use (see podcast_player_controller.js).
//
// Deferred to the next animation frame on purpose: the player controller's
// connect() runs restoreFromStorage(), which HIDES the dock on a fresh page
// load. If we dispatched synchronously in our connect(), the player might
// hide the dock right after we opened it. requestAnimationFrame guarantees
// our dispatch runs after both controllers' synchronous connect work.
//
// Browser autoplay policy may block actual sound after a navigation (the
// click gesture doesn't carry across the page load). That's fine: the
// player handles the rejected play() by staying visible and primed, so the
// user taps once to start. The explicit Play button on the page carries a
// real gesture and always works.
export default class extends Controller {
  static values = { audioUrl: String, title: String, show: String, thumbnail: String }

  connect() {
    if (!this.audioUrlValue) return
    // Track the frame so a fast navigation away before it fires can cancel it
    // (otherwise the deferred dispatch would start audio on the next page).
    this.frameId = requestAnimationFrame(() => {
      window.dispatchEvent(new CustomEvent("podcast:play", {
        detail: {
          audioUrl: this.audioUrlValue,
          title: this.titleValue,
          show: this.showValue,
          thumbnail: this.thumbnailValue
        }
      }))
    })
  }

  disconnect() {
    if (this.frameId) cancelAnimationFrame(this.frameId)
  }
}
